import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-choose-zero',
    imports: [CommonModule, TranslateModule],
    templateUrl: './choose-zero.component.html',
    styleUrl: './choose-zero.component.scss'
})
export class ChooseZeroComponent {
  @Input() showDownloadButton = true;
  @Input() chooseZero!: TemplateRef<any>;
}
